export default __webpack_public_path__ + "static/media/grid_view_icon_red.ed4366d1.svg";